export default __webpack_public_path__ + "static/media/p3-22.730d37d9.png";